import React from 'react';
import PropTypes from 'prop-types';

const SpriteIcon = ({
  className,
  svg,
  width,
  height,
  onClick,
  id,
  tabIndex,
  role,
  expanded,
  haspopup
}) => (
  <svg
    className={className}
    viewBox={svg.viewBox}
    width={width}
    height={height}
    id={id}
    onClick={onClick}
    tabIndex={tabIndex}
    role={role}
    aria-expanded={expanded}
    aria-haspopup={haspopup}
  >
    <use xlinkHref={`#${svg.id}`} />
  </svg>
);

SpriteIcon.propTypes = {
  className: PropTypes.string,
  svg: PropTypes.shape({
    viewBox: PropTypes.string,
    url: PropTypes.string
  }).isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  onClick: PropTypes.func,
  id: PropTypes.string,
  tabIndex: PropTypes.string,
  role: PropTypes.string
};

export default SpriteIcon;
